<template>
    <div class="form-builder">
        <div class="mobileBlocker">
            <div class="mobileBlockerContainer">
                <h4>Dispositivo no compatible</h4>
                <div>
                    El editor de documentos no es compatible en este dispositivo
                </div>
                <div class="mt-4">
                    <i class="fas fa-mobile-retro"></i>
                </div>
                <button class="btn btn-sm btn-primary mt-4" @click="$router.push('/forms-list')">Regresar</button>
            </div>
        </div>
        <div class="fb-header">
            <img src="staticAssets/formBuilder/docsplus.png" style="max-width: 90px">
            <div class="buttons-config">
                <div class="btn btn-outline-primary mr-2" @click="showKeyboardShortcuts">
                    <i class="fas fa-keyboard"></i>
                </div>
                <div class="btn btn-primary mr-2" @click="showVarList">
                    <i class="fas fa-list-check"></i>
                </div>
                <button @click="decreasePageZoom()" class="btn btn-primary mr-2">
                    <i class="fa-solid fa-magnifying-glass-minus"></i>
                </button>
                <button @click="increasePageZoom()" class="btn btn-primary mr-2">
                    <i class="fa-solid fa-magnifying-glass-plus"></i>
                </button>
                <div class="btn btn-primary mr-2">
                    <i class="fas fa-plus mr-2"></i> Agregar objeto
                    <div class="fb-header-submenu">
                        <div class="objectItem" @click="addObject('type_field_static_image')">
                            <div class="fb-header-submenu-img my-2">
                                <i class="fas fa-image mr-1"></i><span>Imagen</span>
                            </div>
                        </div>
                        <div class="objectItem" @click="addObject('type_field_text')">
                            <div class="fb-header-submenu-img my-2">
                                <i class="fas fa-a mr-1"></i><span>Texto</span>
                            </div>
                        </div>
                        <div class="objectItem" @click="addObject('type_field_static_table')">
                            <div class="fb-header-submenu-img my-2">
                                <i class="fas fa-table mr-1"></i><span>Tabla</span>
                            </div>
                        </div>
                        <div class="objectItem" @click="showWhiteLabelFields = true">
                            Desde
                            <div class="fb-header-submenu-img">
                                <img :src="whiteLabelInfo.logoUrl" :alt="whiteLabelInfo.nombre" style="max-width: 100px; max-height: 20px"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn btn-dark mr-2" @click="generateDOC">
                    <i class="fas fa-eye mr-2"></i> Previsualizar
                </div>
                <div class="btn btn-dark mr-2" @click="saveForm">
                    <i class="fas fa-save mr-2"></i> Guardar
                </div>
                <div class="btn btn-dark" @click="pageModalShow = true">
                    <i class="fas fa-cog mr-2"></i> Configuración
                </div>
                <div class="btn btn-danger ml-2" @click="$router.push('/forms-list')">
                    <i class="fas fa-door-closed mr-2"></i> Salir
                </div>
            </div>
        </div>
        <div>
            <div class="fb-toolbar">
                <div id="toolsButtons" class="toolsButtons">
                    <div :class="(this.pageSelected === key) ? 'miniPageItem pageSelected' : 'miniPageItem'" v-for="(item, key) in template.pages" :key="'page_' + key">
                        <div @click="selectPage(key)" class="text-center miniPageItemShow">
                            Página<br>
                            # {{ key + 1 }}
                        </div>
                        <div class="miniPageBtn">
                            <span class="pageBtn trashPage" @click="removePage(key)"><i class="fas fa-trash"></i></span>
                            <span class="pageBtn trashPage" @click="copyPage(key)"><i class="fa-solid fa-copy"></i></span>
                            <span class="pageBtn pageBtnUp" @click="upPage(key)"><i class="fas fa-arrow-alt-circle-up"></i></span>
                            <span class="pageBtn pageBtnDown" @click="downPage(key)"><i class="fas fa-arrow-alt-circle-down"></i></span>
                        </div>
                        <div @click="createPage(true)" class="btn btn-primary btn-sm w-100 btnAddPage">
                            <i class="fa fa-plus-circle mr-1"></i> Página
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="text-center text-muted mt-2">
                        {{ template.numP }} página(s)
                    </div>
                    <div>
                        <div class="loadFile">
                            <button class="btn btn-success btn-sm w-100 mt-4">
                                <i class="fa fa-file-pdf mr-1"></i> Crear desde PDF
                            </button>
                            <input id="loadPageFromPdf" type="file" accept="application/pdf" class="loadFile" @change="showFromPdf = true"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fb-editor">
                <div class="pageContainer">
                    <template v-if="template.pages[pageSelected] !== undefined">
                        <div class="text-small text-muted">
                            {{ template.pages[pageSelected].size.w }}x{{ template.pages[pageSelected].size.h }}mm
                        </div>
                        <div
                            id="page"
                            :class="'page ' + ((typeof template.pages[pageSelected].inserto !== 'undefined' && template.pages[pageSelected].inserto) ? 'pageInserto' : '')"
                            @click="unselectObject"
                            :style="{
                                height: template.pages[pageSelected].size.h+'mm',
                                width: template.pages[pageSelected].size.w+'mm',
                                backgroundImage: ((template.pages[pageSelected].bk !== '') ? 'url('+template.pages[pageSelected].bk+')' : 'inherit'),
                                backgroundSize: ((template.pages[pageSelected].bkw !== '') ? (template.pages[pageSelected].bkw + '% ' + template.pages[pageSelected].bkh + '%') : 'contain'),
                                transform: `scale(${scale})`,
                                'transform-origin': 'left top',
                        }">
                            <div class="pageRuler" @click="unselectObject">
                                <div class="attachmentFont" v-if="template.pages[pageSelected].attachment">
                                    <span class="textAttachment">
                                        Esta página es un componente que permite la creación de un documento a través de un servicio.
                                    </span>
                                    <span class="textAttachment">
                                        [[{{ template.pages[pageSelected].attachment }}]]
                                    </span>
                                </div>
                                <ul class="ruler-x">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <ul class="ruler-y">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                            <div :class="(this.objectSelected === parseInt(key)) ? 'object objectSelected' : 'object'" v-for="(item, key) in template.pages[pageSelected].objects" :key="item.id" :id="item.id" :data-key="key" :style="{top: item.y + 'px',left: item.x+'px', height: item.h+'px', width: item.w+'px', transform: 'rotate('+ item.rotate+'deg)', zIndex: (typeof item.zin !== 'undefined' ? item.zin : key)}">
                                <!--{{item.xmm}}x{{item.ymm}}-->
                                <!-- Si es un objeto del whitelabel -->
                                <div class="objectContent">
                                    <template v-if="item.wl && item.wl !== ''">
                                        <div class="type_field_text whiteLabelObject">{{ item.wl }}</div>
                                    </template>
                                    <template v-else>
                                        <div v-if="!item.type">
                                            {{ item.slug }}
                                        </div>
                                        <div v-if="item.type === 'type_field_text'">
                                            <div class="type_field_text" v-if="(item.shortcode && item.shortcode !== '')">{{ item.shortcode }}</div>
                                            <div class="type_field_text" v-else-if="(item.value && item.value !== '')" v-html="item.value" style="display: flex; flex-direction: column; align-items: flex-start;"></div>
                                            <span v-else>Sin texto</span>
                                        </div>
                                        <div v-if="item.type === 'type_field_static_image'">
                                            <img class="type_field_static_image" :src="item.value? item.value : 'staticAssets/global/noimage.svg'" :style="{height: (item.h-2)+'px', width: item.w+'px'}"/>
                                        </div>
                                        <div v-if="item.type === 'type_field_static_table'">
                                            <table v-if="!!item.dataTable" :style="{'border-collapse': 'separate', 'border-spacing': `0 ${item.dataTable.rowSpace}mm`}" :class="{'type_field_static_table enableBorder': !!item.dataTable.showBorder, 'type_field_static_table': !item.dataTable.showBorder}">
                                                <thead :style="{ visibility: item.dataTable.head.show? 'visible': 'collapse'}">
                                                <tr :style="{ height: `${item.dataTable.head.data.height}mm`}">
                                                    <th v-for="(val, valIndex) in item.dataTable.head.data.data" :key="valIndex"
                                                        :style="{
                                                    width: `${val.width}mm`,
                                                    height: '100%',
                                                    minWidth: `${val.width}mm`,
                                                    background: val.background
                                                    }"
                                                        @click="onSelectCellHead(val.id, valIndex)"
                                                    >
                                                    <textarea v-if="cellHeadSelected === val.id"
                                                              v-model="val.value"
                                                              :style="{
                                                            maxHeight: `${item.dataTable.head.data.height}mm`,
                                                            height: `${item.dataTable.head.data.height}mm`,
                                                            width: '100%'
                                                        }"
                                                              @blur="onSelectCellHead(null)"></textarea>
                                                        <div v-else
                                                             :style="{
                                                        color: val.color,
                                                        fontSize:`${val.fontS}mm`,
                                                        fontFamily: val.fontF,
                                                        fontWeight: val.fontW,
                                                        wordWrap: 'break-word',
                                                        display: 'inline-block',
                                                        width: '100%',
                                                        minWidth: '100%',
                                                        maxWidth: '100%'}"
                                                        >
                                                            {{ val.value }}
                                                        </div>
                                                        <div class="tableDragSizeWidth tableDragResizer" :data-col="valIndex" :data-key="key"></div>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(row, rowIndex) in item.dataTable.body" :key="rowIndex" :style="{ height: `${row.height}mm` }">
                                                    <td v-for="(cel, colIndex) in row.data"
                                                        :colspan="cel.spanCol"
                                                        :rowspan="cel.spanRow"
                                                        :key="cel.id"
                                                        :style="{
                                                    height: '100%',
                                                    background: cel.background}"
                                                        @click="onSelectCell(cel.id, colIndex, rowIndex)">
                                                    <textarea v-if="cellSelected === cel.id" v-model="cel.value"
                                                              :style="{maxHeight: `${row.height}mm`, height: `${row.height}mm`, width: '100%'}"
                                                              @blur="onSelectCell(null)"></textarea>
                                                        <div v-else
                                                             :style="{
                                                        background: cel.background,
                                                        color: cel.color,
                                                        fontSize:`${cel.fontS}mm`,
                                                        fontFamily: cel.fontF,
                                                        fontWeight: cel.fontW,
                                                        wordWrap: 'break-word',
                                                        display: 'inline-block',
                                                        width: '100%',
                                                        minWidth: '100%',
                                                        maxWidth: '100%'}"
                                                        >
                                                            {{ cel.value }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                </div>
                                <div class="rotateObject" v-if="!item.isTextField" @mousedown="rotateObjectStart($event, key, item.id)"><img src="staticAssets/global/rotateimg.png"/></div>
                                <div class="resizeRect"></div>
                                <div class="cloneObject ignoreTap" @click="copyObject(objectSelected, key)"><i class="fas fa-copy ignoreTap"></i></div>
                            </div>
                            <div class="insertoInPage" v-if="typeof template.pages[pageSelected].inserto !== 'undefined' && template.pages[pageSelected].inserto">
                                <embed :src="template.pages[pageSelected].inserto">
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div :class="(textEditorClosed ? 'fb-text-editor closed-text-editor' : 'fb-text-editor')" v-if="typeof template.pages[pageSelected] !== 'undefined' && typeof template.pages[pageSelected].objects[objectSelected] !== 'undefined' && template.pages[pageSelected].objects[objectSelected].type === 'type_field_text'">
                <div class="closeTab" @click="textEditorClosed = !textEditorClosed">
                    <i v-if="!textEditorClosed" class="fas fa-chevron-down"></i>
                    <i v-if="textEditorClosed" class="fas fa-chevron-up"></i>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <h6 class="mb-1">Contenido</h6>
                    </div>
                    <div class="col-12 col-sm-8">
                        <div class="text-muted mt-1 mb-3 text-small text-right">
                            Puede agregar códigos cortos (shortcodes) dentro del editor ej.
                        </div>
                    </div>
                </div>
                <div class="fb-text-editor-container">
                    <div class="textquill">
                        <!--<quill-editor :toolbar="quillToolbar" theme="snow" v-model:content="template.pages[pageSelected].objects[objectSelected].value" contentType="html" @textChange="resizeObject(objectSelected, 'type_field_text'); advancedHtmlContent = template.pages[pageSelected].objects[objectSelected].value"></quill-editor>-->
                        <quill-editor :toolbar="quillToolbar" theme="snow" v-model:content="template.pages[pageSelected].objects[objectSelected].value" contentType="html" @textChange="advancedHtmlContent = template.pages[pageSelected].objects[objectSelected].value"></quill-editor>
                    </div>
                    <div class="text-right">
                        <div class="mt-2 mb-1">
                            <a class="advancedMode" v-if="!template.pages[pageSelected].objects[objectSelected].shtml" @click="template.pages[pageSelected].objects[objectSelected].shtml = true"><i class="fas fa-code"></i> Ver modo avanzado (HTML)</a>
                            <a class="advancedMode" v-if="template.pages[pageSelected].objects[objectSelected].shtml" @click="template.pages[pageSelected].objects[objectSelected].shtml = false"><i class="fas fa-times"></i> Cerrar modo avanzado (HTML)</a>
                        </div>
                        <textarea v-if="typeof template.pages[pageSelected].objects[objectSelected].shtml !== 'undefined' && template.pages[pageSelected].objects[objectSelected].shtml" class="form-control advancedModeTextArea mt-2 mb-4" rows="5" v-model="advancedHtmlContent" @change="template.pages[pageSelected].objects[objectSelected].value = advancedHtmlContent"></textarea>
                    </div>
                </div>
            </div>
            <div class="fb-properties">
                <template v-if="barSelected === 'props'">
                    <div v-if="this.objectSelected === null">
                        <template v-if="pageSelected !== null">
                            <div class="propbar-title">
                                <h6>
                                    Propiedades de página
                                </h6>
                            </div>
                            <div class="propbar-content">
                                <div v-if="typeof template.pages[pageSelected] !== 'undefined'">
                                    <div v-if="!template.pages[pageSelected].inserto">
                                        <div>
                                            <div>
                                                <label>Fondo de página</label>
                                                <div class="loadFile">
                                                    <button class="btn btn-primary btn-sm w-100 mt-2">
                                                        <i class="fas fa-upload mr-2"></i>Seleccionar imagen
                                                    </button>
                                                    <input id="loadPageBackground" type="file" accept="image/*" class="loadFile" @change="loadPageBackground"/>
                                                    <div class="text-muted text-small mt-2">Puede configurar el fondo de su página desde una imagen</div>
                                                    <div class="text-muted my-2 text-small">
                                                        <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].bkDis">
                                                            <div class="toggle-switch"></div>
                                                            <span class="toggle-label">Desactivar impresión de fondo</span></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3">
                                                <label class="font-weight-bold">Tamaño de fondo</label>
                                                <div class="row">
                                                    <div class="col">
                                                        <label>Ancho</label>
                                                        <div class="input-group mb-3">
                                                            <input type="number" class="form-control" v-model="template.pages[pageSelected].bkw" @keydown="slugCreate"/>
                                                            <div class="input-group-append">
                                                                <span class="input-group-text" id="basic-addon1">%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <label>Alto</label>
                                                        <div class="input-group mb-3">
                                                            <input type="number" class="form-control" v-model="template.pages[pageSelected].bkh" @keydown="slugCreate"/>
                                                            <div class="input-group-append">
                                                                <span class="input-group-text" id="basic-addon1">%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="font-weight-bold">Tamaño de página</label>
                                            <div class="row">
                                                <div class="col">
                                                    <label>Ancho</label>
                                                    <div class="input-group mb-3">
                                                        <input type="number" class="form-control" v-model="template.pages[pageSelected].size.w" @keydown="slugCreate"/>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text" id="basic-addon1">mm</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <label>Alto</label>
                                                    <div class="input-group mb-3">
                                                        <input type="number" class="form-control" v-model="template.pages[pageSelected].size.h" @keydown="slugCreate"/>
                                                        <div class="input-group-append">
                                                            <span class="input-group-text" id="basic-addon1">mm</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label>Tamaños de papel estándar</label>
                                            <select class="form-control" @change="changeDefaultSizePage" v-model="changeDefaultSizePageSelected">
                                                <option value=""> - Seleccione una opción -</option>
                                                <option value="letter">Carta (Letter)</option>
                                                <option value="legal">Legal (Legal)</option>
                                            </select>
                                        </div>
                                        <div class="mt-2">
                                            <label>Rotación de página (Beta)</label>
                                            <select class="form-control" v-model="template.pages[pageSelected].rotation">
                                                <option value=""> - Sin rotación -</option>
                                                <option value="90">90 grados</option>
                                                <!--<option value="180">180 grados</option>-->
                                            </select>
                                            <small class="text-muted mt-2">La rotación se realiza en sentido horario</small>
                                        </div>
                                        <div class="mt-2">
                                            <label>Tipografía por defecto</label>
                                            <select class="form-control" v-model="template.pages[pageSelected].fontDefault">
                                                <option value=""> - Sin fuente predeterminada -</option>
                                                <option :value="item" v-for="item in fontsWhiteList" :key="'font'+item">{{ item }}</option>
                                            </select>
                                            <small class="text-muted mt-2">Si selecciona una fuente por defecto, toda la página tomará dicho tipo de letra. Algunas fuentes por defecto no aplican formato a texto como negrita, cursiva, etc. Debe seleccionar la tipografía en el campo específico para aplicar estos formatos</small>
                                        </div>
                                        <!--<div class="mt-2">
                                            <label class="font-weight-bold mb-3">Márgenes</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Arriba</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.mt"/>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Abajo</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.mb"/>
                                            </div>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Izquierda</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.ml"/>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Derecha</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.mr"/>
                                            </div>
                                        </div>-->
                                        <div class="mt-2">
                                            <label class="font-weight-bold mb-3">Páginas autogeneradas</label>
                                            <div>
                                                <small class="text-muted">
                                                    Estas se crean cuando el contenido de una tabla supera el tamaño de página, con lo cual, se genera una página nueva para continuar con el contenido.
                                                </small>
                                            </div>
                                            <label class="my-3">Márgenes de seguridad</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Superior</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.mst"/>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Inferior</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.msb"/>
                                                <!--<div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Abajo</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.msb"/>-->
                                            </div>
                                            <!--<div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Izquierda</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.msl"/>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">Derecha</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="template.pages[pageSelected].size.msr"/>
                                            </div>-->
                                            <div class="text-muted my-2 text-small">
                                                <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].repB">
                                                    <div class="toggle-switch"></div>
                                                    <span class="toggle-label">Replicar fondo de página</span></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="my-3">
                                        Las páginas de tipo inserto no pueden ser ajustadas en tamaño debido a que respetarán el tamaño del inserto.
                                    </div>
                                    <div class="mt-2">
                                        <hr>
                                        <div>
                                            <label v-if="typeof template.pages[pageSelected].inserto !== 'undefined' && template.pages[pageSelected].inserto">Cambiar inserto</label>
                                            <label v-else>Convertir en inserto</label>
                                            <div class="loadFile">
                                                <button class="btn btn-primary w-100 btn-sm mt-2">
                                                    <i class="fas fa-upload mr-2"></i>Seleccionar archivo
                                                </button>
                                                <input id="loadInsertFile" type="file" accept="application/pdf" class="loadFile" @change="loadInserto"/>
                                            </div>
                                            <hr>
                                            <div class="mt-4 mb-4">
                                                <label>
                                                    Reemplazar página mediante código corto (shortcode)
                                                </label>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">[[</span>
                                                    </div>
                                                    <input type="text" class="form-control" v-model="template.pages[pageSelected].attachment" @keydown="slugCreate">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">]]</span>
                                                    </div>
                                                </div>
                                                <div class="text-muted text-small">
                                                    Los códigos cortos o shortcodes permiten reemplazar su valor a través de la creación de documento mediante servicios. Ejemplo:
                                                    <br>
                                                    <div class="text-center mt-2">[[URL_DE_IMAGEN]] &nbsp;&nbsp;&nbsp;ó&nbsp;&nbsp;&nbsp; [[TEXTO_RANDOM]]</div>
                                                </div>
                                            </div>
                                            <small class="text-muted mt-2">Los insertos permiten agregar documentos PDF adicionales entre páginas</small>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="mt-2">
                                        <label class="font-weight-bold">Condicionales</label>
                                        <div v-if="typeof template.pages[pageSelected].conditional !== 'undefined'">
                                            <div v-for="(dependencias, indexDep) in template.pages[pageSelected].conditional" :key="indexDep">
                                                <div class="input-group">
                                                    <select v-model="dependencias.glue" class="form-control" v-if="indexDep !== 0" style="max-width: 40px">
                                                        <option value="AND">Y</option>
                                                        <option value="OR">Ó</option>
                                                    </select>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="dependencias.campoShort"
                                                        placeholder="variable"
                                                    />
                                                    <select v-model="dependencias.campoIs" class="form-control" style="max-width: 40px">
                                                        <option value="=">=</option>
                                                        <option value="<>">!=</option>
                                                        <option value=">">&gt;</option>
                                                        <option value="<">&lt;</option>
                                                        <option value=">=">&gt;=</option>
                                                        <option value="<=">&lt;=</option>
                                                        <option value="C">C</option>
                                                        <option value="CL">CL</option>
                                                    </select>
                                                    <input
                                                        type="text"
                                                        v-model="dependencias.campoValue"
                                                        class="form-control"
                                                        placeholder="valor"
                                                    />
                                                    <input
                                                        v-if="dependencias.campoIs === 'CL'"
                                                        type="text"
                                                        v-model="dependencias.cLs"
                                                        class="form-control"
                                                        placeholder=","
                                                    />
                                                </div>
                                                <div class="text-right">
                                                    <div class="removeConditional" @click="removeConditionalPage(indexDep)">
                                                        Eliminar
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-end mb-3">
                                            <div class="btn btn-sm btn-primary py-0 me-2"
                                                 @click="addConditionalPage()">+
                                            </div>
                                        </div>
                                        <div class="text-muted text-small">
                                            Las condicionales personalizan documentos verificando los valores de los shortcodes a través de condiciones.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-else>
                        <template v-if="typeof template.pages[pageSelected] !== 'undefined'">
                            <div class="propbar-title">
                                <h6>
                                    Propiedades de
                                    <template v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_text'">Texto</template>
                                    <template v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_static_image'">Imagen</template>
                                    <template v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_static_table'">Tabla</template>
                                </h6>
                            </div>
                            <div class="propbar-content">
                                <div class="row">
                                    <div class="col-8">
                                        <h6 class="mb-1">Configuración de campo</h6>
                                    </div>
                                    <div class="col-4">
                                        <button @click="removeObject(objectSelected)" class="objectConfig btn btn-danger btn-sm float-right" style="margin-left: 5px;">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                        <button @click="copyObject(objectSelected)" class="objectConfig btn btn-primary btn-sm float-right">
                                            <i class="fa-solid fa-copy"></i>
                                        </button>
                                    </div>
                                </div>
                                <!--<div>
                                    <label>Tipo de objeto</label>
                                    <select class="form-control" v-model="template.pages[pageSelected].objects[objectSelected].type">
                                        <option value="type_field_text">Texto</option>
                                        <option value="type_field_static_image">Imagen</option>
                                        <option value="type_field_static_table">Tabla</option>
                                    </select>
                                    <div class="text-muted text-center text-small mt-3" v-if="!template.pages[pageSelected].objects[objectSelected].type || template.pages[pageSelected].objects[objectSelected].type === ''">
                                        Selecciona el tipo de objeto para continuar
                                    </div>
                                </div>-->
                                <div class="mt-3">
                                    <div v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_text'">
                                        <div class="my-2">
                                            <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].objects[objectSelected].isTextField">
                                                <div class="toggle-switch"></div>
                                                <span class="toggle-label">Convertir en campo editable (en PDF)</span></label>
                                        </div>
                                        <div  v-if="typeof template.pages[pageSelected].objects[objectSelected].isTextField !== 'undefined' && template.pages[pageSelected].objects[objectSelected].isTextField">
                                            <div class="my-2">
                                                <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].objects[objectSelected].blkMl">
                                                    <div class="toggle-switch"></div>
                                                    <span class="toggle-label">Bloquear multilínea</span></label>
                                            </div>
                                            <div class="my-3">
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">Máximo de caracteres</span>
                                                    </div>
                                                    <input class="form-control" type="number"
                                                           v-model="template.pages[pageSelected].objects[objectSelected].maxCh"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <label class="font-weight-bold">Condicionales</label>
                                        <div>
                                            <div v-for="(dependencias, indexDep) in template.pages[pageSelected].objects[objectSelected].conditional ? template.pages[pageSelected].objects[objectSelected].conditional : []" :key="indexDep">
                                                <div class="input-group">
                                                    <select v-model="dependencias.glue" class="form-control" v-if="indexDep !== 0" style="max-width: 40px">
                                                        <option value="AND">Y</option>
                                                        <option value="OR">Ó</option>
                                                    </select>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="dependencias.campoShort"
                                                        placeholder="variable"
                                                    />
                                                    <select v-model="dependencias.campoIs" class="form-control" style="max-width: 40px">
                                                        <option value="=">=</option>
                                                        <option value="<>">!=</option>
                                                        <option value=">">&gt;</option>
                                                        <option value="<">&lt;</option>
                                                        <option value=">=">&gt;=</option>
                                                        <option value="<=">&lt;=</option>
                                                        <option value="C">C</option>
                                                        <option value="CL">CL</option>
                                                    </select>
                                                    <input
                                                        type="text"
                                                        v-model="dependencias.campoValue"
                                                        class="form-control"
                                                        placeholder="valor"
                                                    />
                                                    <input
                                                        v-if="dependencias.campoIs === 'CL'"
                                                        type="text"
                                                        v-model="dependencias.cLs"
                                                        class="form-control"
                                                        placeholder=","
                                                    />
                                                </div>
                                                <div class="text-right">
                                                    <div class="removeConditional" @click="removeConditionalObject(objectSelected, indexDep)">
                                                        Eliminar
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-end mb-3">
                                                <div class="btn btn-sm btn-primary py-0 me-2" @click="addConditionalObject(objectSelected)">+</div>
                                            </div>
                                        </div>
                                        <div class="text-muted text-small">
                                            Las condicionales personalizan documentos verificando los valores de los shortcodes a través de condiciones.
                                        </div>
                                    </div>
                                    <div class="my-4" v-if="template.pages[pageSelected].objects[objectSelected].type">
                                        <label>
                                            <span v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_static_image'">Reemplazar URL de imagen</span>
                                            <span v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_text'">Reemplazar texto</span>
                                            <span v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_static_table'">Reemplazar tabla</span>
                                            mediante código corto (shortcode)
                                        </label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">[[</span>
                                            </div>
                                            <input type="text" class="form-control" v-model="template.pages[pageSelected].objects[objectSelected].shortcode" @keydown="slugCreate">
                                            <div class="input-group-append">
                                                <span class="input-group-text">]]</span>
                                            </div>
                                        </div>
                                        <div class="text-muted text-small">
                                            Los códigos cortos o shortcodes permiten reemplazar su valor a través de la creación de documento mediante servicios. Ejemplo:
                                            <br>
                                            <div class="text-center mt-2">[[URL_DE_IMAGEN]] &nbsp;&nbsp;&nbsp;ó&nbsp;&nbsp;&nbsp; [[TEXTO_RANDOM]]</div>
                                        </div>
                                        <div v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_static_image'"
                                             class="text-muted my-3 text-small">
                                            <input type="checkbox" v-model="template.pages[pageSelected].objects[objectSelected].maintainAspect"/>
                                            Mantener proporciones (según ancho)
                                        </div>
                                    </div>
                                    <div v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_static_image'">
                                        <h6 class="mb-3">Cargar imagen</h6>
                                        <div class="loadFile">
                                            <button class="btn btn-primary w-100">
                                                <i class="fas fa-upload mr-2"></i>Seleccionar archivo
                                            </button>
                                            <input id="type_field_static_image" type="file" accept="image/*" class="loadFile" @change="loadStaticImage"/>
                                        </div>
                                        <h6 class="mt-3 mb-3">Convertir imagen en código QR o barras</h6>
                                        <div>
                                            <select class="form-control" v-model="template.pages[pageSelected].objects[objectSelected].imgQrBar" @change="imgToQRBAR(objectSelected)">
                                                <optgroup label="Código de barras">
                                                    <option value="QRH">QR alta definición</option>
                                                    <option value="QRM">QR media definición</option>
                                                    <option value="QRL">QR baja definición</option>
                                                </optgroup>
                                                <optgroup label="Código QR">
                                                    <option value="code39">Code 39</option>
                                                    <option value="code39_ext">Code 39 extendido</option>
                                                    <option value="code128">Code 128</option>
                                                    <option value="ean13">EAN 13</option>
                                                </optgroup>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-if="template.pages[pageSelected].objects[objectSelected].type === 'type_field_static_table'">
                                        <h6 class="mb-3">Configuración de la tabla</h6>
                                        <!--                                <div v-if="!template.pages[pageSelected].objects[objectSelected].dataTable" class="input-group mb-3">
                                                                            <input type="number" class="form-control" placeholder="# DE COLUMNAS" v-model="template.pages[pageSelected].objects[objectSelected].col">
                                                                            <input type="number" class="form-control" placeholder="# DE FILAS" v-model="template.pages[pageSelected].objects[objectSelected].row">
                                                                            <br/>
                                                                            <button class="btn btn-sm btn-primary py-0 me-2" @click="generateTable(objectSelected)">Generar tabla</button>
                                                                        </div>-->
                                        <div v-if="!!template.pages[pageSelected].objects[objectSelected].dataTable" class="mb-3">
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="mb-3">
                                                        <div>
                                                            <span class="mr-2">Columnas:</span>
                                                        </div>
                                                        <div>
                                                            <button class="btn btn-sm btn-primary py-0 mr-2" @click="addCol(objectSelected)">+</button>
                                                            <button class="btn btn-sm btn-danger py-0 mr-2" @click="deleteCol(objectSelected)">-</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="mb-3">
                                                        <div>
                                                            <span class="mr-2">Filas:</span>
                                                        </div>
                                                        <div>
                                                            <button class="btn btn-sm btn-primary py-0 mr-2" @click="addRow(objectSelected)">+</button>
                                                            <button class="btn btn-sm btn-danger py-0 mr-2" @click="deleteRow(objectSelected)">-</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="input-group mb-3">
                                                <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].objects[objectSelected].dataTable.head.show" @change="onChangeShowHead(objectSelected)">
                                                <div class="toggle-switch"></div>
                                                <span class="toggle-label">Habilitar encabezados</span></label>
                                            </div>
                                            <div class="input-group mb-3">
                                                <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].objects[objectSelected].dataTable.head.hDina" @change="onChangeShowHead(objectSelected)">
                                                <div class="toggle-switch"></div>
                                                <span class="toggle-label">Encabezados dinámicos</span></label>
                                            </div>
                                            <div class="input-group mb-3">
                                                <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].objects[objectSelected].dataTable.showBorder" @change="onChangeShowHead(objectSelected)">
                                                    <div class="toggle-switch"></div>
                                                    <span class="toggle-label">Mostrar borde</span>
                                                </label>
                                            </div>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon3">Espacio entre filas:</span>
                                                </div>
                                                <input class="form-control" type="number"
                                                       v-model="template.pages[pageSelected].objects[objectSelected].dataTable.rowSpace"
                                                       @input="onChangeRowHeight(objectSelected)"/>
                                            </div>
                                            <div class="mb-3">
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">Tamaño de letra</span>
                                                    </div>
                                                    <input class="form-control" type="number" v-model="template.pages[pageSelected].objects[objectSelected].dataTable.fSize"/>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="input-group mb-3">
                                                    <label class="toggle"><input class="toggle-checkbox" type="checkbox" v-model="template.pages[pageSelected].objects[objectSelected].dataTable.head.adWmax" @change="onChangeShowHead(objectSelected)">
                                                        <div class="toggle-switch"></div>
                                                        <span class="toggle-label">Ajustar tabla al ancho del contenedor</span></label>
                                                </div>
                                                <div class="text-muted text-small">
                                                    Ajusta la tabla al ancho máximo del contenedor dibujado en caso sea más pequeña, solo aplica para tablas con encabezados dinámicos
                                                </div>
                                            </div>
                                            <div v-if="!!cellSelected">

                                                <!-- <div class="input-group mb-3">
                                                    <span class="mr-2">Tramo:</span>
                                                    <input class="form-control" type="number"
                                                    v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].spanCol"
                                                    @input="onVerifySpanCol($event, objectSelected)"/>
                                                    <input class="form-control" type="number"
                                                    v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].spanRow"
                                                    @input="onVerifySpanRow($event, objectSelected)"/>
                                                </div> -->
                                                <!--                                        <div class="input-group mb-3">
                                                                                            <span class="mr-2">Color de Fondo:</span>
                                                                                            <select
                                                                                                v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].background"
                                                                                                :style="{background: template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].background}"
                                                                                                class="form-control">
                                                                                                <option :style="{background: color}" :value="color"
                                                                                                        v-for="(color, indexColor) in cellColor" :key="indexColor">{{ color }}
                                                                                                </option>
                                                                                            </select>
                                                                                        </div>
                                                                                        <div class="mb-3">
                                                                                            <div class="input-group mb-3">
                                                                                                <div class="input-group-prepend">
                                                                                                    <span class="input-group-text" id="basic-addon3">Tamaño de letra:</span>
                                                                                                </div>
                                                                                                <select v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].fontS" class="form-control">
                                                                                                    <option v-for="(size, indexSize) in cellFontSize" :key="indexSize" :value="size">{{ size }}</option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="mb-3">
                                                                                            <div class="input-group mb-3">
                                                                                                <div class="input-group-prepend">
                                                                                                    <span class="input-group-text" id="basic-addon3">Color de letra:</span>
                                                                                                </div>
                                                                                                <select v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].color" class="form-control">
                                                                                                    <option v-for="(size, indexSize) in cellFontSize" :key="indexSize" :value="size">{{ size }}</option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="input-group mb-3">
                                                                                            <span class="mr-2">Color de letra:</span>
                                                                                            <select
                                                                                                v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].color"
                                                                                                class="form-control"
                                                                                                :style="{background: template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].color}"
                                                                                            >
                                                                                                <option :style="{background: color}" :value="color"
                                                                                                        v-for="(color, indexColor) in cellColor" :key="indexColor"></option>
                                                                                            </select>
                                                                                        </div>
                                                                                        <div class="input-group mb-3">
                                                                                            <span class="mr-2">Tipo de letra:</span>
                                                                                            <select v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].fontF" class="form-control">
                                                                                                <option v-for="(font, indexfont) in cellFontFamily" :value="font.name" :key="indexfont">{{ font.name }}</option>
                                                                                            </select>
                                                                                        </div>
                                                                                        <div class="input-group mb-3">
                                                                                            <span class="mr-2">Grosor de letra:</span>
                                                                                            <select v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].data[cellColSelected].fontW" class="form-control">
                                                                                                <option v-for="(font, indexfont) in cellFontWeight" :value="font" :key="indexfont">{{ font }}</option>
                                                                                            </select>
                                                                                        </div>-->
                                                <!--<h6 class="mb-3">Caracteristicas de la Columna</h6>
                                                <div class="input-group mb-3">
                                                    <span class="mr-2">Ancho:</span>
                                                    <input class="form-control" type="number"
                                                           v-model="template.pages[pageSelected].objects[objectSelected].dataTable.head.data.data[cellColSelected].width"
                                                           @input="onChangeColWidth(objectSelected)"/>
                                                </div>
                                                <h6 class="mb-3">Caracteristicas de la Fila</h6>
                                                <div class="input-group mb-3">
                                                    <span class="mr-2">Alto:</span>
                                                    <input class="form-control" type="number"
                                                           v-model="template.pages[pageSelected].objects[objectSelected].dataTable.body[cellRowSelected].height"
                                                           @input="onChangeRowHeight(objectSelected)"/>
                                                </div>-->
                                            </div>
                                            <div v-if="!!cellHeadSelected && (typeof template.pages[pageSelected].objects[objectSelected] !== 'undefined' && typeof template.pages[pageSelected].objects[objectSelected].dataTable.head.data.data[cellColSelected] !== 'undefined')">
                                                <h6 class="mb-3 mt-3">Características de encabezado</h6>
                                                <div>
                                                    <div class="input-group mb-3">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon3">Ancho:</span>
                                                        </div>
                                                        <input class="form-control" type="number"
                                                               v-model="template.pages[pageSelected].objects[objectSelected].dataTable.head.data.data[cellColSelected].width"/>
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon3">Alto:</span>
                                                        </div>
                                                        <input class="form-control" type="number"
                                                               v-model="template.pages[pageSelected].objects[objectSelected].dataTable.head.data.height"/>
                                                    </div>
                                                </div>
                                                <h6 class="mb-3 mt-3">Características de columna</h6>
                                                <div>
                                                    <div class="input-group mb-3">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon3">Alineación</span>
                                                        </div>
                                                        <select class="form-control" v-model="template.pages[pageSelected].objects[objectSelected].dataTable.head.data.data[cellColSelected].alignT">
                                                            <option value="L">Izquierda</option>
                                                            <option value="C">Centrada</option>
                                                            <option value="R">Derecha</option>
                                                            <option value="J">Justificado</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-else-if="barSelected === 'layers'">
                    <div v-if="typeof template.pages[pageSelected] !== 'undefined'">
                        <div class="propbar-title">
                            <h6>Objetos de página</h6>
                        </div>
                        <div class="propbar-content">
                            <div class="text-muted text-small mb-3">
                                La superposición de objetos solo está disponible para imágenes
                            </div>
                            <div class="layerBox">
                                <!--<div class="row itemLayer"  :key="'layer_' + item.id"  v-for="(item) in template.pages[pageSelected].objects">
                                    <div class="col-2">
                                        <div v-if="item.type === 'type_field_static_image'" class="image"><img :src="item.value"/></div>
                                        <div v-if="item.type === 'type_field_text'" class="text"><i class="fas fa-a"></i></div>
                                    </div>
                                    <div class="col-10 labelLayer">
                                        <span v-if="item.type === 'type_field_static_image'">Capa de tipo imagen</span>
                                        <span v-if="item.type === 'type_field_text'">Capa de tipo texto</span>
                                    </div>
                                </div>-->
                                <draggable
                                    :list="layerList"
                                    item-key="name"
                                    ghost-class="ghost"
                                    handle=".itemLayerHandle"
                                    @start="layerDragging = true"
                                    @end="layerCheckMove"
                                >
                                    <template #item="{ element }">
                                        <div :class="(objectSelected === element.key ? 'itemLayer selected' : 'itemLayer')" @mousedown="objectSelected = element.key">
                                            <div class="row">
                                                <div class="col-2">
                                                    <div v-if="element.type === 'type_field_static_image'" class="itemLayerHandle image"><img :src="element.value"/></div>
                                                    <div v-if="element.type === 'type_field_text'" class="itemLayerHandle text"><i class="fas fa-a"></i></div>
                                                </div>
                                                <div class="col-10 labelLayer">
                                                    <input type="text" class="form-control" v-model="template.pages[pageSelected].objects[element.key].ln" style="width: 90%; display: inline" :placeholder="cleanLabel(element)">
                                                    <span @click="removeObject(objectSelected)" class="deleteLayerBtn"><i class="fas fa-trash"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <!--Barra de selección de barras xd-->
            <div class="fb-properties-selector">
                <div @click="barSelected = 'props'" :class="(barSelected === 'props' ? 'btn-selector selected' : 'btn-selector')"  v-tooltip="'Propiedades'"><i class="fas fa-bars"></i></div>
                <div @click="barSelected = 'layers'"  :class="(barSelected === 'layers' ? 'btn-selector selected' : 'btn-selector')"  v-tooltip="'Capas'"><i class="fas fa-layer-group"></i></div>
            </div>
        </div>
        <div class="form-config-modal" v-show="pageModalShow">
            <div class="form-config-modal-container">
                <div>
                    <div class="mb-4">
                        <h6>Token de formulario</h6>
                        <div class="text-center">
                            {{ pageConfig.token }}
                        </div>
                    </div>
                    <div class="mb-4">
                        <h6>Nombre de formulario</h6>
                        <div>
                            <input class="form-control" type="text" v-model="pageConfig.name"/>
                        </div>
                    </div>
                    <div v-if="pageConfig.password !== null" class="mb-4">
                        <h6>Contraseña:</h6>
                        <div>
                            <input class="form-control" type="text" v-model="pageConfig.password"/>
                        </div>
                    </div>
                    <div class="mb-4">
                        <input type="checkbox" :checked="pageConfig.password !== null" @change="changeEnablePassword" class="mr-2"/>
                        <span>Agregar proteccion con contraseña</span>
                    </div>
                    <div class="mb-4">
                        <input type="checkbox" v-model="pageConfig.signature" class="mr-2"/>
                        <span>Agregar proteccion con firma digital</span>
                    </div>
                    <div class="mb-4">
                        Importar/Exportar configuración
                        <div class="text-center my-2 mb-3">
                            <button class="btn btn-primary btn-sm mr-2" @click="exportForm">
                                <i class="fas fa-download mr-2"></i>Exportar plantilla
                            </button>
                            <label class="btn btn-primary btn-sm m-0" for="importTpl">
                                <i class="fas fa-upload mr-2"></i>Importar plantilla
                            </label>
                            <input id="importTpl" type='file' class="form-control" accept='text/flow' @change='importForm($event)' style="display: none">
                        </div>
                        <a id="downloadAnchorElem" style="display:none"></a>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <button class="btn btn-success w-100" @click="saveForm()">Guardar</button>
                    </div>
                    <div class="col-6">
                        <button v-if="this.pageConfig.id > 0" class="btn btn-danger w-100" @click="pageModalShow = false">Cancelar</button>
                        <button v-else class="btn btn-danger w-100" onclick="window.history.go(-1); return false;">Regresar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-config-modal" v-show="showCompressDetails">
            <div class="form-config-modal-container">
                <div>
                    <div>
                        <h5 class="mb-3 text-center">Calidad de imagen</h5>
                        <hr>
                        <div>
                            La calidad de imagen determina el nivel de compresión a utilizar.
                        </div>
                        <div class="mt-2">
                            <select class="form-control" v-model="compressLevel">
                                <option value="ultralow">Ultra bajo</option>
                                <option value="low">Bajo</option>
                                <option value="medium">Medio</option>
                                <option value="high">Alto</option>
                                <option value="ultra">Ultra</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 col-sm-6 text-center">
                        <button class="btn btn-success w-100" @click="compressSelected">Continuar</button>
                    </div>
                    <div class="col-12 col-sm-6 text-center">
                        <button class="btn btn-danger w-100" @click="showCompressDetails = false; compressLevel = 'medium'; compressType = false">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-config-modal" v-show="showFromPdf">
            <div class="form-config-modal-container">
                <div>
                    <div>
                        <h5 class="mb-3 text-center">Nivel de compresión</h5>
                        <hr>
                        <div>
                            La calidad de imagen determina el nivel de compresión a utilizar.
                        </div>
                        <div class="mt-2">
                            <select class="form-control" v-model="fromPdfCompressLevel">
                                <option value="ultralow">Ultra bajo</option>
                                <option value="low">Bajo</option>
                                <option value="medium">Medio</option>
                                <option value="high">Alto</option>
                                <option value="ultra">Ultra</option>
                            </select>
                        </div>
                        <div class="mt-2">
                            <label>Rango de páginas</label>
                            <input type="text" class="form-control" v-model="fromPdfRange"/>
                            <div class="text-small text-muted mt-3">
                                (*) todas, ejemplos: *, 1, 3, 2-6, 12-16, 6-*
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 col-sm-6 text-center">
                        <button class="btn btn-success w-100" @click="createPageFromPdf">Continuar</button>
                    </div>
                    <div class="col-12 col-sm-6 text-center">
                        <button class="btn btn-danger w-100" @click="showFromPdf = false; fromPdfCompressLevel = 'medium';">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-config-modal" v-show="showKeyboardShortcutsModal">
            <div class="form-config-modal-container">
                <div>
                    <div>
                        <h5 class="mb-3 text-center">Listado de atajos de teclado</h5>
                        <hr>
                        <div class="row mb-2">
                            <div class="col-2">
                                <kbd class="keyboard-shortcut">Shift</kbd>
                            </div>
                            <div class="col-10">
                                Desactivar bloquedo de relación de aspecto al cambiar tamaño de objetos.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <button class="btn btn-success w-100" @click="showKeyboardShortcutsModal = false">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-config-modal" v-show="showVarListModal">
            <div class="form-config-modal-container">
                <div>
                    <div>
                        <h5 class="mb-3 text-center">Listado de variables</h5>
                        <div class="text-muted text-center text-small">Atención, no se muestran objetos que no tengan una variable de reemplazo</div>
                        <div v-for="(page, key) in varList" :key="'page_' + key">
                            <table class="table table-striped tableCompact">
                                <thead>
                                <th>
                                    Tipo
                                </th>
                                <th>
                                    Valor
                                </th>
                                </thead>
                                <tbody>
                                <tr v-for="(item, keyItem) in page" :key="keyItem">
                                    <td>{{item.type}}</td>
                                    <td>{{item.var}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <button class="btn btn-success w-100" @click="showVarListModal = false">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-config-modal" v-show="showWhiteLabelFields">
            <div class="form-config-modal-container">
                <div class="mb-4">
                    <div v-for="(campos, agrupador) in wlFields" :key="agrupador" class="mb-3">
                        <h6>{{ agrupador }}</h6>
                        <div v-for="(modulo, moduloTitle) in campos" :key="moduloTitle">
                            <div class="text-muted">{{ moduloTitle }}</div>
                            <div class="mt-2">
                                <button @click="addObjectWl(field, moduloTitle + '/' + fieldName)" class="btn btn-primary btn-sm mr-1 mb-2 buttonFieldWl" v-for="(fieldName, field) in modulo" :key="field">{{ fieldName }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 text-right">
                    <button class="btn btn-danger btn-sm" @click="showWhiteLabelFields = false">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import "/src/layout/admin/assets/css/form-builder.css";
import {mapGetters} from "vuex";
import API from "src/core/Api";
import interact from 'interactjs'

import {QuillEditor} from '@vueup/vue-quill'
import Quill from 'quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import {Twitter} from '@ckpack/vue-color';
import draggable from 'vuedraggable'
// json forms
//import {JsonForms} from '@jsonforms/vue';
//import {vanillaRenderers} from '@jsonforms/vue-vanilla';

/*const renderers = [
    ...vanillaRenderers,
    // here you can add custom renderers
];*/

export default {
    components: {
        draggable,
        QuillEditor,
    },
    computed: {
        ...mapGetters({
            whiteLabelInfo: 'whiteLabelInfo',
            AuthGetUserInfo: 'AuthGetUserInfo',
        })
    },
    data() {
        return {
            // configuración de vista
            barSelected: 'props',
            layerList: [],
            layerDragging: false,
            textEditorClosed: false,

            // configuración de página
            showVarListModal: false,
            showKeyboardShortcutsModal: false,
            pageModalShow: false,
            pageConfig: {
                id: 0,
                name: '',
                token: '',
                type: 'informationSend',
                orientation: 'vertical',
                enablePdf: false,
                backgroundUrl: '',
                extraData: {
                    formId: 0,
                },
                password: null
            },
            selectModifyObject: false,
            varList: {},

            // crear desde pdf
            fromPdfCompressLevel: 'medium',
            fromPdfRange: '*',
            showFromPdf: false,

            // compresión
            compressType: false,
            compressLevel: 'medium',
            showCompressDetails: false,

            // PDF
            /*pdfDraggerContainer: false,
            pdfDraggers: {},*/

            // pagina
            changeDefaultSizePageSelected: '',
            scale: 0.9,
            bAR: true,
            screenDPI: 96,
            screenDPIY: 96,
            objectSelected: null,
            pageSelected: 0,
            template: {
                numP: 0,
                pages: [],
            },

            // objetos
            rotatingObjectKey: false,
            rotatingObjectId: false,

            // campos para whitelabels
            wlFields: {},
            showWhiteLabelFields: false,

            // Quill y editor de texto
            fontsWhiteList: [],
            quillToolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'color': []}],
                [{'font': ['Helvetica', 'CutiveMono', 'Courier', 'Times', 'Roboto', 'Symbol', 'OpenSans', 'Lato', 'Nanum', 'Rubik', 'Pacifico', 'Dinot', 'VictorMono']}],
                [{'align': []}],
                [{'size': ['2mm', '3mm', '4mm', '5mm', '6mm', '8mm', '10mm', '12mm']}],
                ['link']
            ],
            advancedHtmlContent: '',

            // Tablas
            celWidthDefault: 40,
            celHeightDefault: 10,
            alignTDefault: 'L',
            cellSelected: '',
            cellBorderColorDefault: '#000000',
            cellBackgroundColorDefault: '#FFFFFF99',
            cellFontSizeDefault: 4,
            cellFontFamilyDefault: 'Helvetica',
            cellColorDefault: 'black',
            cellRowSelected: '',
            cellColSelected: '',
            cellHeadSelected: '',
            cellFontSize: [2, 3, 4, 5, 6, 8, 10, 12],
            cellFontFamily: [{name: 'Helvetica'}, {name: 'Courier'}, {name: 'Times'}, {name: 'Symbol'}],
            cellFontWeightDefault: 'normal',
            cellFontWeight: ['normal', 'bold'],
            cellColor: [
                /*Blanco:*/ '#FFFFFF',
                /*Rosa: */ '#FFC0CB',
                /*Amarillo: */ '#FFFF00',
                /*Verde:*/ '#008000',
                /*Azul */ '#0000FF',
                /*Naranja:*/ '#FFA500',
                /*Gris:*/ '#808080',
                /*Morado:*/ '#800080',
                /*Rojo:*/ '#FF0000',
                /*Negro:*/ '#000000'
            ]
        };
    },
    mounted() {

        const self = this;
        this.screenDPI = this.calculateDPI();
        this.screenDPIY = this.calculateDPIY();
        this.createPage();

        // Fuentes
        this.fontsWhiteList = ['Helvetica', 'CutiveMono', 'Courier', 'Times', 'Roboto', 'Symbol', 'OpenSans', 'Lato', 'Nanum', 'Rubik', 'Pacifico', 'Dinot', 'VictorMono'];

        // cargo el id del form
        if (parseInt(this.$route.params.id) > 0) {

            API.send('GET', '/formularios/form-builder-v2/by/id/' + this.$route.params.id, {},
                function (response) {
                    //console.log(response.data.template);
                    if (response.status) {
                        self.pageConfig.id = response.data.id;
                        self.pageConfig.name = response.data.descripcion;
                        self.pageConfig.token = response.data.token;
                        self.pageConfig.type = response.data.typeForm;
                        self.pageConfig.orientation = response.data.orientation;
                        self.pageConfig.extraData.formId = response.data.id;
                        self.pageConfig.backgroundUrl = response.data.backgroundUrl;
                        self.pageConfig.enablePdf = !!(response.data.enablePdfRender);
                        self.pageConfig.password = response.data.password;
                        self.template = response.data.template;

                        if (typeof self.template.pages !== 'undefined' && typeof self.template.pages.length !== 'undefined') {
                            self.template.numP = self.template.pages.length;
                        }

                        self.refreshDrag();
                    }
                },
                function (response) {
                    API.showErrorNotify(response.msg);
                })
        }
        else {
            this.pageModalShow = true;
        }

        const font = Quill.import('formats/font')
        // We do not add Aref Ruqaa since it is the default
        font.whitelist = this.fontsWhiteList;
        Quill.register(font, true);

        const Size = Quill.import('attributors/style/size');
        Size.whitelist = ['2mm', '3mm', '4mm', '5mm', '6mm', '8mm', '10mm', '12mm', '16mm', '18mm', '20mm'];
        Quill.register(Size, true);

        // Aspect ratio
        window.addEventListener('keydown', function (e) {
            if (e.key === 'Shift') {
                self.bAR = false;
            }
        })
        window.addEventListener('keyup', function (e) {
            if (e.key === 'Shift') {
                self.bAR = true;
            }
        });

        // traemos los campos
        this.getWhiteBrandObject();
    },
    methods: {
        // genericos
        showKeyboardShortcuts() {
            this.showKeyboardShortcutsModal = true;
        },
        calculateDPI() {
            const el = document.createElement('div');
            el.style = 'width: 1in;'
            document.body.appendChild(el);
            const dpi = el.offsetWidth;
            document.body.removeChild(el);
            return dpi;
        },
        calculateDPIY() {
            const el = document.createElement('div');
            el.style = 'height: 1in;'
            document.body.appendChild(el);
            const dpi = el.offsetHeight;
            document.body.removeChild(el);
            return dpi;
        },
        saveForm(handler) {
            const self = this;
            if (!handler) {
                handler = false;
            }
            const data = {
                idForm: self.pageConfig.id,
                descripcion: self.pageConfig.name,
                /*type: self.pageConfig.type,*/
                /*orientation: self.pageConfig.orientation,
                enablePdf: (self.pageConfig.enablePdf) ? 1 : 0,*/
                template: self.template,
                password: self.pageConfig.password,
            };

            API.send('POST', 'formularios/form-builder-v2/save/', data, function (response) {
                    if (data.idForm === 0) {
                        if (typeof response.data.id !== 'undefined' && parseInt(response.data.id) > 0) {
                            window.location.href = '/form-builder/' + response.data.id
                        }
                    }
                    else {
                        API.showSuccessAlert(response.msg);
                        self.pageModalShow = false;

                        if (typeof handler === 'function') {
                            handler();
                        }
                    }
                },
                function (response) {
                    API.showErrorNotify(response.msg);
                })
        },
        exportForm() {
            const self = this;
            const data = {
                pageConfig: self.pageConfig,
                template: self.template,
            };
            const nameFile = data.pageConfig.name + '.dcpl';

            let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data));
            let dlAnchorElem = document.getElementById('downloadAnchorElem');
            dlAnchorElem.setAttribute("href", dataStr);
            dlAnchorElem.setAttribute("download", nameFile);
            dlAnchorElem.click();
        },
        importForm(event) {
            const self = this;
            API.showConfirm('Se sobreescribirá este flujo, ¿desea continuar?', '', function () {

                let input = event.target;

                let reader = new FileReader();
                reader.onload = function () {
                    var text = reader.result;
                    let flowConfig = JSON.parse(text);
                    self.pageConfig = flowConfig.pageConfig;
                    self.template = flowConfig.template;
                    self.pageModalShow = false;
                };
                reader.readAsText(input.files[0]);
            });
        },
        generateDOC() {
            const self = this;

            const data = {
                token: self.pageConfig.token,
                operation: 'preview',
                password: self.pageConfig.password,
            };

            API.showInfoAlert('La vista previa NO guarda cambios al generarse');

            API.send('POST', 'formularios/docs-plus/generate', data, function (response) {

                    if (typeof response.data.fileData !== 'undefined') {
                        const binary = atob(response.data.fileData.replace(/\s/g, ''));
                        const len = binary.length;
                        const buffer = new ArrayBuffer(len);
                        let view = new Uint8Array(buffer);
                        for (let i = 0; i < len; i++) {
                            view[i] = binary.charCodeAt(i);
                        }
                        const blob = new Blob([view], {type: 'application/pdf'});
                        const blobURL = URL.createObjectURL(blob);
                        window.open(blobURL);
                    }
                },
                function (response) {
                    API.showErrorAlert(response.msg);
                })

            /*this.saveForm(function () {



            })*/

            /*API.send('POST', 'formularios/docs-plus/generate', data, function (response) {

                    if (typeof response.data.fileData !== 'undefined') {
                        const binary = atob(response.data.fileData.replace(/\s/g, ''));
                        const len = binary.length;
                        const buffer = new ArrayBuffer(len);
                        let view = new Uint8Array(buffer);
                        for (let i = 0; i < len; i++) {
                            view[i] = binary.charCodeAt(i);
                        }
                        const blob = new Blob([view], {type: 'application/pdf'});
                        const blobURL = URL.createObjectURL(blob);
                        window.open(blobURL);
                    }
                },
                function (response) {
                    API.showErrorAlert(response.msg);
                })*/
        },
        arrayMove(old_index, new_index) {
            if (new_index >= this.template.pages.length) {
                var k = new_index - this.template.pages.length + 1;
                while (k--) {
                    this.template.pages.push(undefined);
                }
            }
            this.template.pages.splice(new_index, 0, this.template.pages.splice(old_index, 1)[0]);
        },
        showVarList() {

            const self = this;
            API.send('POST', 'formularios/form-builder/get-var-list', {
                    token: self.pageConfig.token,
                }, function (response) {
                    self.showVarListModal = true;
                    self.varList = response.data;
                },
                function (response) {
                    API.showErrorAlert(response.msg);
                })
        },
        layerCheckMove: function(e) {
            this.layerDragging = false;
            const self = this;
            if (typeof this.template.pages[this.pageSelected].objects !== 'undefined') {

                const tmpLayerOrder = {};
                let reversedList = [...self.layerList];
                reversedList = reversedList.reverse();

                reversedList.forEach(function (item, key) {
                    tmpLayerOrder[item.id] = key;
                });

                self.template.pages[self.pageSelected].objects.forEach(function (object, objKey) {
                    self.template.pages[self.pageSelected].objects[objKey].zin = tmpLayerOrder[object.id];
                })
            }
        },
        layerLoad() {
            const self = this;
            // cargar capas
            self.layerList = [];
            if (typeof this.template.pages[this.pageSelected].objects !== 'undefined') {
                this.template.pages[this.pageSelected].objects.forEach(function (item, key) {
                    self.layerList.push({ type: item.type, value: item.value, key: parseInt(key), id: item.id })
                })
            }
        },
        // Builder (drag and drop y objetos)

        // páginas
        countPages(reindex) {
            if (!reindex) {
                reindex = false;
            }

            // reindexo páginas
            const self = this;
            this.template.pages.forEach(function (a, b) {
                self.template.pages[b].number = b;
            })

            return this.template.pages.length;
        },
        createPage(beforeSelected) {

            const pageNum = this.countPages();
            this.objectSelected = null;

            // cuento las páginas
            this.template.pages.push({
                id: 'pg_' + this.createId(),
                number: pageNum,
                size: {
                    w: 215.9,
                    h: 279.4,
                },
                inserto: '',
                bk: '',
                bkw: 100,
                bkh: 100,
                objects: [],
                attachment: '',
            });

            const lastPage = this.template.pages.length - 1; // -1 porque es un listado y busco la posición del array

            if (beforeSelected) {
                const moveTo = this.pageSelected + 1;
                this.arrayMove(lastPage, moveTo);
                this.pageSelected = moveTo;
                this.template.numP = moveTo;
            }
            else {
                this.pageSelected = pageNum;
                this.template.numP = pageNum;
            }
        },
        removePage(pageToDelete) {
            const self = this;


            API.showConfirm('¿Está seguro que desea eliminar la página?', 'Esta acción no se puede revertir', function () {
                if (typeof self.template.pages[pageToDelete] !== 'undefined') {
                    const deletedPage = pageToDelete;
                    self.template.pages.splice(pageToDelete, 1);
                    self.pageSelected = null;
                    self.objectSelected = null;
                    self.template.numP = self.countPages(true);

                    let pageSelected = 0;
                    if (self.template.numP <= 0) {
                        self.createPage();
                    }
                    if (deletedPage > 0) {
                        pageSelected = deletedPage - 1;
                    }
                    self.selectPage(pageSelected);
                }
            })

            //this.refreshDrag();
        },
        copyPage(pageToCopy) {
            const self = this;
            if (typeof self.template.pages[pageToCopy] !== 'undefined') {
                const copy = JSON.parse(JSON.stringify(self.template.pages[pageToCopy]));
                const pageNum = this.countPages();
                copy['id'] = 'pg_' + this.createId();
                copy['number'] = pageNum;
                copy['objects'] = copy['objects'].map(e => {
                    return {...e, id: self.createId()}
                });
                self.template.pages.push(copy);
            }
        },
        changeDefaultSizePage() {
            const self = this;
            API.showConfirm('Se reemplazará el tamaño del documento', '', function () {
                if (self.changeDefaultSizePageSelected === 'letter') {
                    self.template.pages[self.pageSelected].size.w = 215.9;
                    self.template.pages[self.pageSelected].size.h = 279.4;
                }
                else {
                    if (self.changeDefaultSizePageSelected === 'legal') {
                        self.template.pages[self.pageSelected].size.w = 215.9;
                        self.template.pages[self.pageSelected].size.h = 355.6;
                    }
                }
                self.changeDefaultSizePageSelected = '';
            })
        },
        createPageFromPdf() {

            const self = this;
            const file = document.getElementById('loadPageFromPdf').files[0];

            const fd = new FormData();
            fd.append('file', file);
            fd.append('level', this.fromPdfCompressLevel);
            fd.append('range', this.fromPdfRange);

            API.send('FILE', 'formularios/docs-plus/load-from-pdf', fd, function (response) {
                    API.showSuccessAlert(response.msg);
                    if (typeof response.data !== 'undefined') {
                        response.data.forEach(function (a) {
                            self.createPage();
                            self.template.pages[self.pageSelected].bk = a;
                        })
                        self.fromPdfRange = '*';
                        self.fromPdfCompressLevel = 'medium';
                        self.showFromPdf = false;
                    }
                },
                function (response) {
                    API.showErrorAlert(response.msg);
                })
        },
        loadPageBackground() {
            this.compressType = 'pageBackground';
            this.showCompressDetails = true;
        },
        upPage(numberItem) {
            const moveTo = numberItem - 1;
            this.selectPage(moveTo);
            this.arrayMove(numberItem, moveTo);
        },
        downPage(numberItem) {
            const moveTo = numberItem + 1;
            this.selectPage(moveTo);
            this.arrayMove(numberItem, moveTo);
        },

        // objetos
        createId() {
            let result = '';
            let timeId = new Date().valueOf();
            const length = 5;
            const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
            return result + '_' + timeId;
        },
        createObject(type) {
            if (!type) {
                type = '';
            }
            return {
                id: this.createId(),
                x: 30,
                y: 30,
                w: 200,
                h: 20,
                ow: 0, // original width
                oh: 0, // original height
                xmm: 0, // milímetros
                ymm: 0, // milímetros
                wmm: 0, // milímetros
                hmm: 0, // milímetros
                /*slug: 'CAMPO',*/
                shortcode: '',
                value: '',
                fontS: 15, // Font size
                fontF: 'sans-serif', // Font family
                wl: '', // Font family
                type: type, // tipo de campo
                zin: 0, // profundidad
                ln: '', // Layer name
            }
        },
        addObject(type) {

            const object = this.createObject(type);
            this.template.pages[this.pageSelected].objects.push(object);
            this.objectSelected = this.template.pages[this.pageSelected].objects.length - 1;

            // valores por defecto
            if (type === 'type_field_static_image') {
                object.value = 'data:image/jpeg;base64,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';
                object.w = '100';
                object.h = '100';
                object.ow = '100';
                object.oh = '100';
                object.wmm = (object.w * 25.4) / this.screenDPI;
                object.hmm = (object.h * 25.4) / this.screenDPIY;
            }
            else {
                if (type === 'type_field_text') {
                    object.value = 'Campo de texto';
                }
                else {
                    if (type === 'type_field_static_table') {
                        // columnas por defecto
                        this.template.pages[this.pageSelected].objects[this.objectSelected].col = 3;
                        this.template.pages[this.pageSelected].objects[this.objectSelected].row = 3;
                        this.generateTable(this.objectSelected);
                    }
                }
            }
            //this.resizeObject(this.objectSelected, 'type_field_static_image');
            this.refreshDrag();
        },
        addObjectWl(shortCode, textShow) {
            const object = this.createObject('type_field_text');
            object.wl = textShow;
            object.shortcode = shortCode;
            this.template.pages[this.pageSelected].objects.push(object);
            this.refreshDrag();
            this.showWhiteLabelFields = false;
        },
        removeObject(objectSelected) {
            if (typeof this.template.pages[this.pageSelected].objects[objectSelected] !== 'undefined') {
                this.template.pages[this.pageSelected].objects.splice(objectSelected, 1)
                this.objectSelected = null;
            }
            this.refreshDrag();
        },
        copyObject(objectSelected, itemToCopyKey) {

            if (!objectSelected) {
                objectSelected = itemToCopyKey;
            }

            const object = JSON.parse(JSON.stringify(this.template.pages[this.pageSelected].objects[objectSelected]));
            const objectCopy = {
                ...object,
                id: this.createId(),
                x: object.x + 40,
                y: object.y + 40,
            };
            this.template.pages[this.pageSelected].objects.push(objectCopy);
            this.refreshDrag();
        },
        selectPage(pageNumber) {
            this.objectSelected = null;
            this.pageSelected = pageNumber;
            this.layerLoad();
        },
        unselectObject(e) {
            if (e.target === e.currentTarget) {
                this.objectSelected = null;
            }
        },

        listenRotation(e) {

            const element = document.getElementById(this.rotatingObjectId);

            let rect = element.getBoundingClientRect();
            const center_x = (rect.left) + (rect.width / 2);
            const center_y = (rect.top) + (rect.height / 2);
            const mouse_x = e.pageX;
            const mouse_y = e.pageY;
            const radians = Math.atan2(center_y - mouse_y, center_x - mouse_x);

            const degree = (radians * (180 / Math.PI));
            this.template.pages[this.pageSelected].objects[this.rotatingObjectKey].rotate = degree;

        },
        rotateObjectStop() {
            this.rotatingObjectId = false;
            this.rotatingObjectKey = false;
            window.removeEventListener('mousemove', this.listenRotation,false);
        },
        rotateObjectStart(event, key, id) {

            event.preventDefault(); // prevents the dragging of the image.
            this.rotatingObjectId = id;
            this.rotatingObjectKey = key;
            window.addEventListener('mousemove', this.listenRotation,false);
            window.addEventListener('mouseup', this.rotateObjectStop);
        },

        // Move, aqui se maneja todo el drag
        refreshDrag() {
            // target elements with the "draggable" class
            const self = this;

            const findUpTag = function (el, className) {
                if (el.classList.contains(className)) {
                    return el;
                }
                else {
                    while (el.parentNode) {
                        el = el.parentNode;
                        if (el.classList.contains(className)) {
                            return el;
                        }
                    }
                }
                return null;
            }

            interact('.object')
                .draggable({
                    // enable inertial throwing
                    inertia: true,
                    // keep the element within the area of it's parent
                    modifiers: [
                        /*interact.modifiers.restrictRect({
                            restriction: 'parent',
                            endOnly: true
                        }),*/
                    ],
                    // enable autoScroll
                    autoScroll: true,

                    listeners: {
                        move: function (event) {

                            if (!self.rotatingObjectId) {
                                const target = event.target;
                                const objectSelectedKey = parseInt(event.target.getAttribute('data-key'));

                                const x = parseFloat(self.template.pages[self.pageSelected].objects[objectSelectedKey].x) + event.dx / self.scale;
                                const y = parseFloat(self.template.pages[self.pageSelected].objects[objectSelectedKey].y) + event.dy / self.scale;

                                // translate the element
                                target.style.left = x + 'px';
                                target.style.top = y + 'px';

                                // update the posiion attributes
                                self.template.pages[self.pageSelected].objects[objectSelectedKey].x = x;
                                self.template.pages[self.pageSelected].objects[objectSelectedKey].y = y;
                                self.template.pages[self.pageSelected].objects[objectSelectedKey].xmm = (x * 25.4) / self.screenDPI;
                                self.template.pages[self.pageSelected].objects[objectSelectedKey].ymm = (y * 25.4) / self.screenDPIY; // menos 3% por padding
                            }
                        },
                    }
                }).on('tap', function (event) {

                    if (event.target.classList.contains('ignoreTap')) {
                        return false;
                    }

                    const object = findUpTag(event.target, 'object');
                    if (object) {
                        self.objectSelected = parseInt(object.getAttribute('data-key'));
                    }

                    if (typeof self.template.pages[self.pageSelected] !== 'undefined' && typeof self.template.pages[self.pageSelected].objects[self.objectSelected] !== 'undefined' && typeof self.template.pages[self.pageSelected].objects[self.objectSelected].value !== 'undefined') {
                        self.advancedHtmlContent = self.template.pages[self.pageSelected].objects[self.objectSelected].value;
                    }
            }).resizable({
                edges: {top: false, left: false, bottom: true, right: true},
                margin: 5,
                listeners: {
                    move: function (event) {

                        // selección de objeto
                        const objectSelectedKey = parseInt(event.target.getAttribute('data-key'));

                        // Si el objeto seleccionado no tiene tamaño original, lo guardo
                        if (!self.template.pages[self.pageSelected].objects[objectSelectedKey].ow) {
                            self.template.pages[self.pageSelected].objects[objectSelectedKey].ow = event.rect.width;
                        }
                        if (!self.template.pages[self.pageSelected].objects[objectSelectedKey].oh) {
                            self.template.pages[self.pageSelected].objects[objectSelectedKey].oh = event.rect.height;
                        }

                        // calculo tamaño
                        let width = (event.rect.width) / self.scale;
                        let height = (event.rect.height) / self.scale;
                        let ratio = (self.template.pages[self.pageSelected].objects[objectSelectedKey].oh / self.template.pages[self.pageSelected].objects[objectSelectedKey].ow);

                        if (self.bAR && self.template.pages[self.pageSelected].objects[objectSelectedKey].type === 'type_field_static_image') {
                            height = width * ratio;
                        }

                        // evita que se vuelvan invisibles los objetos
                        if (height <= 10 || width <= 10) {
                            return false;
                        }

                        Object.assign(event.target.style, {
                            width: `${width}px`,
                            height: `${height}px`,
                        })

                        self.template.pages[self.pageSelected].objects[objectSelectedKey].w = width;
                        self.template.pages[self.pageSelected].objects[objectSelectedKey].h = height;

                        self.template.pages[self.pageSelected].objects[objectSelectedKey].wmm = (width * 25.4) / self.screenDPI;
                        self.template.pages[self.pageSelected].objects[objectSelectedKey].hmm = (height * 25.4) / self.screenDPIY;

                        // Cambio de tamaño de imagen interna
                        if (self.template.pages[self.pageSelected].objects[objectSelectedKey].type === 'type_field_static_image') {
                            const image = document.getElementById(self.template.pages[self.pageSelected].objects[objectSelectedKey].id).getElementsByClassName('type_field_static_image');
                            Object.assign(image[0].style, {
                                width: `${width}px`,
                                height: `${height}px`,
                            })
                        }

                        // is Table, al cambiar tamaño cambia las columnas también por lo cual hay que mejorarlo, es mejor desactivarlo de momento
                        /*if(self.template.pages[self.pageSelected].objects[objectSelectedKey].type === 'type_field_static_table' &&
                            !!self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable
                        ) self.onChangeObjectTableSize(objectSelectedKey)*/
                    }
                }
            });

            interact('.tableDragResizer')
                .draggable({
                    // enable inertial throwing
                    inertia: true,
                    // keep the element within the area of it's parent
                    modifiers: [
                        /*interact.modifiers.restrictRect({
                            restriction: 'parent',
                            endOnly: true
                        }),*/
                    ],
                    // enable autoScroll
                    autoScroll: true,

                    listeners: {
                        move: function (event) {
                            const colSelected = parseInt(event.target.getAttribute('data-col'));
                            const objectSelectedKey = parseInt(event.target.getAttribute('data-key'));
                            const actualWidth = self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable.head.data.data[colSelected].width;
                            const x = event.dx / self.scale;
                            self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable.head.data.data[colSelected].width = actualWidth + ((x * 25.4) / self.screenDPI);
                        },
                    }
                })

            this.layerLoad();
        },
        resizeObject(objectSelected, className) {
            const self = this;
            setTimeout(function () {
                const object = document.getElementById(self.template.pages[self.pageSelected].objects[objectSelected].id);
                const objectForSize = object.getElementsByClassName(className);
                if (typeof objectForSize[0] !== 'undefined') {
                    const offsetHeight = objectForSize[0].offsetHeight;
                    self.template.pages[self.pageSelected].objects[objectSelected].h = offsetHeight;
                    Object.assign(object.style, {
                        height: `${offsetHeight}px`,
                    });
                }
                self.layerLoad();
            }, 100);
        },

        // otros
        slugCreate(e) {
            // allowedKeys Safari issues allowing keyCodes through regex - 8 = backspace, 46 = delete, 38 ArrowUp, 40 = ArrowDown, 37 = ArrowLeft, 39 = ArrowRight
            let allowedKeys = [8, 46, 38, 40, 37, 39];
            var keypressed = e.which || e.keyCode;
            if (!/[0-9A-Za-z_]+/.test(e.key)) {
                if (allowedKeys.every(e => e !== keypressed)) {
                    e.preventDefault();
                }
            }
        },
        loadStaticImage() {
            this.compressType = 'imageStatic';
            this.showCompressDetails = true;
        },
        loadInserto() {
            const self = this;
            const file = document.getElementById('loadInsertFile').files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                API.showConfirm('Antes de continuar', 'Si convierte esta página en inserto, se borrarán todos sus objetos', function () {
                    self.template.pages[self.pageSelected].size.w = 215.9;
                    self.template.pages[self.pageSelected].size.h = 355.6;
                    self.template.pages[self.pageSelected].inserto = reader.result;
                    self.template.pages[self.pageSelected].objects = [];
                })
            }
            reader.readAsDataURL(file);
        },
        imgToQRBAR(objectSelected) {
            const self = this;

            if (this.template.pages[self.pageSelected].objects[objectSelected].imgQrBar === 'QRH' || this.template.pages[self.pageSelected].objects[objectSelected].imgQrBar === 'QRM' || this.template.pages[self.pageSelected].objects[objectSelected].imgQrBar === 'QRL') {
                self.template.pages[self.pageSelected].objects[objectSelected].value = '/staticAssets/global/qrcode.png';
                self.template.pages[self.pageSelected].objects[objectSelected].w = 200;
                self.template.pages[self.pageSelected].objects[objectSelected].h = 200;
                self.template.pages[self.pageSelected].objects[objectSelected].ow = 200;
                self.template.pages[self.pageSelected].objects[objectSelected].oh = 200;
            }
            else {
                self.template.pages[self.pageSelected].objects[objectSelected].value = '/staticAssets/global/barcode.png';
                self.template.pages[self.pageSelected].objects[objectSelected].w = 200;
                self.template.pages[self.pageSelected].objects[objectSelected].h = 80;
                self.template.pages[self.pageSelected].objects[objectSelected].ow = 200;
                self.template.pages[self.pageSelected].objects[objectSelected].oh = 80;
            }

            self.resizeObject(objectSelected, 'type_field_static_image');
        },
        compressSelected() {

            const self = this;

            const compressImage = function (filesObject, callback) {

                const fd = new FormData();
                fd.append('file', filesObject);
                fd.append('level', self.compressLevel);
                fd.append('response', 'base64');

                API.send('FILE', 'formularios/docs-plus/image-compress', fd, function (response) {
                        if (typeof callback === 'function') {
                            callback(response);
                        }
                    },
                    function (response) {
                        API.showErrorAlert(response.msg);
                    })
            }

            if (this.compressType === 'pageBackground') {

                const file = document.getElementById('loadPageBackground').files[0];
                const reader = new FileReader();

                reader.onloadend = async () => {
                    //const rawImg = reader.result;

                    compressImage(file, function (response) {
                        if (response.data) {
                            API.showSuccessAlert('Compresión realizada con éxito', 'Comprimido de ' + response.data.original + ' a ' + response.data.compressed + ', ahorrado: ' + response.data.loss);
                            self.template.pages[self.pageSelected].bk = response.data.result;
                            self.compressType = false;
                            self.compressLevel = 'medium';
                            self.showCompressDetails = false;
                        }
                        else {
                            API.showErrorAlert('Error al comprimir imagen, por favor intente de nuevo');
                        }
                    })
                }
                reader.readAsDataURL(file);
            }
            // Image static
            else {
                const objectSelected = self.objectSelected;

                const getDimensions = function (image) {
                    return new Promise((resolve) => {
                        const img = new Image();
                        img.src = image;
                        img.onload = () => {
                            resolve({width: img.width, height: img.height})
                        }
                    })
                }
                const file = document.getElementById('type_field_static_image').files[0];
                const reader = new FileReader();

                reader.onloadend = async () => {

                    compressImage(file, async function (response) {
                        if (response.data) {
                            API.showSuccessAlert('Compresión realizada con éxito', 'Comprimido de ' + response.data.original + ' a ' + response.data.compressed + ', ahorrado: ' + response.data.loss);

                            const rawImg = response.data.result;
                            let dimensions = await getDimensions(rawImg);
                            self.template.pages[self.pageSelected].objects[objectSelected].value = rawImg;
                            self.template.pages[self.pageSelected].objects[objectSelected].w = dimensions.width;
                            self.template.pages[self.pageSelected].objects[objectSelected].h = dimensions.height;
                            self.template.pages[self.pageSelected].objects[objectSelected].ow = dimensions.width;
                            self.template.pages[self.pageSelected].objects[objectSelected].oh = dimensions.height;
                            self.resizeObject(objectSelected, 'type_field_static_image');

                            self.compressType = false;
                            self.compressLevel = 'medium';
                            self.showCompressDetails = false;
                        }
                        else {
                            API.showErrorAlert('Error al comprimir imagen, por favor intente de nuevo');
                        }
                    })

                }
                reader.readAsDataURL(file);
            }
        },
        cleanLabel(element) {

            let tmplabel = 'Capa ' + element.key;

            if (element.type !== 'type_field_static_image') {
                if (typeof element.ln !== 'undefined') {
                    tmplabel = element.ln;
                }
                else {
                    tmplabel = element.value.replace(/<[^>]*>?/gm, '');
                    if (tmplabel.length > 25) {
                        tmplabel = tmplabel.substr(0,10);
                        tmplabel = tmplabel + '...';
                    }
                }
            }
            return tmplabel;
        },

        // Zoom
        increasePageZoom() {
            const self = this;
            if (self.scale <= 2) {
                self.scale = self.scale + 0.1;
            }
        },
        decreasePageZoom() {
            const self = this;
            if (self.scale >= 0.1) {
                self.scale = self.scale - 0.1;
            }
        },

        //Objects Conditional
        addConditionalObject(objectSelected) {
            if (!this.template.pages[this.pageSelected].objects[objectSelected].conditional) {
                this.template.pages[this.pageSelected].objects[objectSelected].conditional = []
            }
            this.template.pages[this.pageSelected].objects[objectSelected].conditional.push(
                {glue: 'AND', campoValue: '', campoShort: '', campoIs: '=', cLs: ''}
            )
        },
        removeConditionalObject(objectSelected, conditionalObjectSelected) {
            if (typeof this.template.pages[this.pageSelected].objects[objectSelected] !== 'undefined') {
                this.template.pages[this.pageSelected].objects[objectSelected].conditional.splice(conditionalObjectSelected, 1)
            }
        },

        //Page Conditional
        addConditionalPage() {
            const self = this;
            if (!self.template.pages[self.pageSelected].conditional) {
                self.template.pages[self.pageSelected].conditional = []
            }
            self.template.pages[self.pageSelected].conditional.push(
                {glue: 'AND', campoValue: '', campoShort: '', campoIs: '=', cLs: ''}
            )
        },
        removeConditionalPage(conditionalPageSelected) {
            const self = this;
            if (typeof self.template.pages[self.pageSelected] !== 'undefined') {
                self.template.pages[self.pageSelected].conditional.splice(conditionalPageSelected, 1)
            }
        },

        //Password
        changeEnablePassword() {
            const self = this;
            if (self.pageConfig.password !== null) {
                self.pageConfig.password = null
            }
            else {
                self.pageConfig.password = ''
            }
        },
        //Table
        createCell() {
            const self = this;
            return {
                id: this.createId(),
                spanCol: 1,
                spanRow: 1,
                value: '',
                color: self.cellColorDefault,
                background: self.cellBackgroundColorDefault,
                fontS: self.cellFontSizeDefault, // Font size
                fontF: self.cellFontFamilyDefault, // Font family
                fontW: self.cellFontWeightDefault,
                width: self.celWidthDefault,
                height: self.celHeightDefault,
                alignT: self.alignTDefault,
            }
        },
        createRow(num = 1) {
            const self = this;
            const newRow = {
                data: new Array(num).fill({}).map(e => {
                    return self.createCell()
                }),
                //height: self.celHeightDefault
            };
            return newRow;
        },
        createTable(col = 1, row = 1) {
            const self = this;
            const newTable = {
                head: {data: self.createRow(col), show: true},
                body: new Array(row).fill({}).map(e => {
                    return self.createRow(col)
                }),
                showBorder: true,
                rowSpace: 0,
                fSize: 12,
            };
            return newTable;
        },
        generateTable(objectSelectedKey) {
            const self = this;
            const object = self.template.pages[self.pageSelected].objects[objectSelectedKey];
            if (object.type === 'type_field_static_table') {
                self.template.pages[self.pageSelected].objects[objectSelectedKey].w = (parseFloat(object.col) * self.celWidthDefault) * self.screenDPI / 25.4;
                self.template.pages[self.pageSelected].objects[objectSelectedKey].h = (parseFloat(object.row) + 1) * (self.celHeightDefault) * self.screenDPIY / 25.4;
                self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable
                    = self.createTable(parseFloat(object.col), parseFloat(object.row));
            }
        },
        addRow(objectSelectedKey) {
            const self = this;
            const object = JSON.parse(JSON.stringify(self.template.pages[self.pageSelected].objects[objectSelectedKey]));
            self.template.pages[self.pageSelected].objects[objectSelectedKey]
                = {
                ...object,
                // h: parseFloat(object.h) + (object.dataTable.rowSpace + self.celHeightDefault)* self.screenDPIY /25.4,
                dataTable: {...object.dataTable, body: [...object.dataTable.body, self.createRow(object.col)]},
                row: object.row + 1
            }
        },
        deleteRow(objectSelectedKey) {
            const self = this;
            const object = JSON.parse(JSON.stringify(self.template.pages[self.pageSelected].objects[objectSelectedKey]));
            self.template.pages[self.pageSelected].objects[objectSelectedKey]
                = {
                ...object,
                //h: parseFloat(object.h)- (object.dataTable.rowSpace + self.celHeightDefault)* self.screenDPI /25.4,
                dataTable: {...object.dataTable, body: object.dataTable.body.toSpliced(-1, 1)},
                row: object.row - 1
            }
        },
        // falta revisar de aqui para abajo
        addCol(objectSelectedKey) {
            const self = this;
            const object = JSON.parse(JSON.stringify(self.template.pages[self.pageSelected].objects[objectSelectedKey]));
            self.template.pages[self.pageSelected].objects[objectSelectedKey]
                = {
                ...object,
                w: parseFloat(object.w) + self.celWidthDefault * self.screenDPI / 25.4,
                dataTable: {
                    ...object.dataTable,
                    head: {
                        ...object.dataTable.head,
                        data: {
                            ...object.dataTable.head.data,
                            data: [...object.dataTable.head.data.data, self.createCell()]
                        }
                    },
                    body: object.dataTable.body.map(e => {
                        return {...e, data: [...e.data, self.createCell()]}
                    }),
                },
                col: object.col + 1
            };
        },
        deleteCol(objectSelectedKey) {
            const self = this;
            const object = JSON.parse(JSON.stringify(self.template.pages[self.pageSelected].objects[objectSelectedKey]));
            self.template.pages[self.pageSelected].objects[objectSelectedKey]
                = {
                ...object,
                // w: parseFloat(object.w)- self.celWidthDefault * self.screenDPI /25.4,
                dataTable: {
                    ...object.dataTable,
                    head: {
                        ...object.dataTable.head,
                        data: {
                            ...object.dataTable.head.data,
                            data: object.dataTable.head.data.data.toSpliced(-1, 1)
                        }
                    },
                    body: object.dataTable.body.map(e => {
                        return {...e, data: e.data.toSpliced(-1, 1)}
                    })
                },
                col: object.col - 1
            }
        },

        onSelectCell(id, col, row) {
            const self = this;
            if (id) {
                self.cellSelected = id;
                self.cellRowSelected = row;
                self.cellColSelected = col;
                self.cellHeadSelected = '';
            }
            else {
                self.cellSelected = '';
            }
        },
        onSelectCellHead(id, cell) {
            const self = this;
            if (id) {
                self.cellSelected = '';
                self.cellHeadSelected = id;
                self.cellColSelected = cell;
            }
            else {
                self.cellHeadSelected = '';
            }
        },
        onVerifySpanCol(event, objectSelectedKey) {
            /* const self = this;

             const object = self.template.pages[self.pageSelected].objects[objectSelectedKey];
             const ncol = object.col;

             const colTotal = object.dataTable[self.cellRowSelected].data.reduce((a,b) => {return a + b.spanCol}, 0);

             const positionAcul = object.dataTable[self.cellRowSelected].data.slice(0, self.cellColSelected).reduce((a,b) => {return a + b.spanCol}, 0);
             let value = Number(event.target.value);

             if(value < 1) value = 1
             else if(positionAcul > ncol + value - 1) value -= (positionAcul - ncol);
             self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable[self.cellRowSelected].data[self.cellColSelected].spanCol
                 = value;

             // evaluar la cantidad de columnas
             if(colTotal > ncol){
                 self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable[self.cellRowSelected].data =
                 object.dataTable[self.cellRowSelected].data.toSpliced(self.cellColSelected+1, value - 1);
             } else {
                 // ABC

             } */
        },
        onVerifySpanRow(event, objectSelectedKey) {
            /* const self = this;

             const object = self.template.pages[self.pageSelected].objects[objectSelectedKey];
             const nrow = object.row;
             const positionAcul = object.dataTable.reduce((a,b) => {
                 return a + b.data[self.cellColSelected].spanRow}, 0);
             let value = Number(event.target.value);

             if(value < 1) value = 1
             else if(positionAcul > nrow + value - 1)value -= (positionAcul - nrow);
             self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable[self.cellRowSelected].data[self.cellColSelected].spanRow
                 = value;

             // evaluar la cantidad de columnas
             self.template.pages[self.pageSelected].objects[objectSelectedKey].dataTable =
                 object.dataTable.map((e,i) => {
                     if((i > self.cellRowSelected) && (i < (self.cellRowSelected + value)))
                     {return {...e, data: e.data.toSpliced(self.cellColSelected+1, 1)}}
                     return e
                 }); */
        },
        onChangeColWidth(objectSelectedKey) {
            const self = this;
            const object = self.template.pages[self.pageSelected].objects[objectSelectedKey];
            console.log(object.dataTable.head.data.data);
            self.template.pages[self.pageSelected].objects[objectSelectedKey]
                = {
                ...object,
                w: object.dataTable.head.data.data.reduce(function (a, b) {
                    return (b.width + a)  * self.screenDPI / 25.4;
                }, 0),
            }
        },
        onChangeRowHeight(objectSelectedKey) {
            const self = this;
            const object = self.template.pages[self.pageSelected].objects[objectSelectedKey];
            self.template.pages[self.pageSelected].objects[objectSelectedKey]
                = {
                ...object,
                h: (
                    object.dataTable.head.data.height +
                    object.dataTable.body.reduce((a, b) => b.height + a, 0) +
                    object.dataTable.rowSpace * (object.row + 1)
                ) * self.screenDPIY / 25.4,
            }
        },
        onChangeShowHead(objectSelectedKey) {
            const self = this;
            const object = self.template.pages[self.pageSelected].objects[objectSelectedKey];
            const value = object.dataTable.head.show;
            self.template.pages[self.pageSelected].objects[objectSelectedKey]
                = {
                ...object,
                h: ((value ? object.dataTable.head.data.height : 0)
                        + object.dataTable.body.reduce((a, b) => b.height + a, 0)) * self.screenDPIY / 25.4
                    + object.dataTable.rowSpace * (object.row + 1) * self.screenDPIY / 25.4
                ,
            }
        },
        onChangeObjectTableSize(objectSelectedKey) {
            const self = this;
            const object = self.template.pages[self.pageSelected].objects[objectSelectedKey];
            const showHead = object.dataTable.head.show;
            const newWidthCell = object.wmm / object.col;
            const newHeightCell = (object.hmm - ((object.row + 1) * object.dataTable.rowSpace)) / (object.row + (showHead ? 1 : 0));
            self.template.pages[self.pageSelected].objects[objectSelectedKey] = {
                ...object,
                dataTable: {
                    ...object.dataTable,
                    head: {
                        ...object.dataTable.head,
                        data: {
                            ...object.dataTable.head.data,
                            data: object.dataTable.head.data.data.map(e => {
                                return {...e, width: newWidthCell}
                            }),
                            height: newHeightCell
                        }
                    },
                    body: object.dataTable.body.map(e => {
                        return {...e, height: newHeightCell}
                    })
                }
            }
        },

        // conexión con any
        getWhiteBrandObject() {
            const self = this;
            API.send('POST', 'formularios/docs-plus/get-wl-fields', {}, function (response) {
                    self.wlFields = response.data;
                },
                function (response) {
                    API.showErrorAlert(response.msg);
                })
        }

    }
};
</script>
